import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as t}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as L}from"../../icon-registry.js";const s=L("venezuela",t`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5H24V9.83333H0V4.5Z"
                fill="#FFCE00" />
            <path
                d="M0 9.83301H24V15.1663H0V9.83301Z"
                fill="#203899" />
            <path
                d="M0 15.167H24V20.5003H0V15.167Z"
                fill="#D82B2B" />
            <path
                d="M12.9385 10.2383L13.0879 10.7289L13.5679 10.8783L13.1519 11.1663L13.1625 11.6783L12.7572 11.3689L12.2772 11.5289L12.4372 11.0596L12.1385 10.6543H12.6399L12.9385 10.2383ZM11.0505 10.2383L11.3385 10.6543H11.8399L11.5412 11.0596L11.7012 11.5396L11.2212 11.3689L10.8159 11.6676L10.8265 11.1663L10.4105 10.8676L10.8905 10.7289L11.0505 10.2383ZM14.7199 10.8356L14.7092 11.3476L15.1252 11.6356L14.6345 11.7849L14.4852 12.2649L14.1972 11.8596H13.6852L13.9945 11.4543L13.8345 10.9743L14.3145 11.1449L14.7199 10.8356ZM9.26921 10.8569L9.69588 11.1449L10.1652 10.9529L10.0265 11.4436L10.3465 11.8276L9.84521 11.8489L9.56788 12.2756L9.39721 11.8063L8.90654 11.6783L9.30121 11.3583L9.26921 10.8569ZM16.2559 12.1049L16.0425 12.5743L16.3092 13.0009L15.8079 12.9476L15.4772 13.3316L15.3705 12.8409L14.9119 12.6489L15.3492 12.3929L15.3812 11.8916L15.7545 12.2223L16.2559 12.1049ZM16.4585 13.2996L16.6825 13.7583L17.1839 13.8329L16.8212 14.1849L16.9065 14.6756L16.4585 14.4409L16.0105 14.6756L16.0959 14.1849L15.7332 13.8329L16.2345 13.7583L16.4585 13.2996ZM7.46654 13.2463L7.69054 13.7049L8.19188 13.7689L7.82921 14.1209L7.91454 14.6223L7.46654 14.3876L7.01854 14.6223L7.10388 14.1209L6.74121 13.7689L7.24254 13.7049L7.46654 13.2463ZM7.79721 12.0196L8.27721 12.1689L8.68254 11.8596V12.3716L9.09854 12.6489L8.61854 12.8089L8.47988 13.2996L8.18121 12.8943L7.67988 12.9049L7.96788 12.4996L7.79721 12.0196Z"
                fill="white" />
        </svg>
    `),l=t`
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        static>
        <mask
            id="mask0_4915_40006"
            style="mask-type:alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24">
            <circle
                cx="12"
                cy="12"
                r="12"
                fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_4915_40006)">
            <g clip-path="url(#clip0_4915_40006)">
                <path
                    d="M-6.03516 0.0664062H29.9648V8.06641H-6.03516V0.0664062Z"
                    fill="#FFCE00" />
                <path
                    d="M-6.03516 8.06641H29.9648V16.0664H-6.03516V8.06641Z"
                    fill="#203899" />
                <path
                    d="M-6.03516 16.0664H29.9648V24.0664H-6.03516V16.0664Z"
                    fill="#D82B2B" />
                <path
                    d="M13.3727 8.67383L13.5967 9.40983L14.3167 9.63383L13.6927 10.0658L13.7087 10.8338L13.1007 10.3698L12.3807 10.6098L12.6207 9.90583L12.1727 9.29783H12.9247L13.3727 8.67383ZM10.5407 8.67383L10.9727 9.29783H11.7247L11.2767 9.90583L11.5167 10.6258L10.7967 10.3698L10.1887 10.8178L10.2047 10.0658L9.58066 9.61783L10.3007 9.40983L10.5407 8.67383ZM16.0447 9.56983L16.0287 10.3378L16.6527 10.7698L15.9167 10.9938L15.6927 11.7138L15.2607 11.1058H14.4927L14.9567 10.4978L14.7167 9.77783L15.4367 10.0338L16.0447 9.56983ZM7.86866 9.60183L8.50866 10.0338L9.21266 9.74583L9.00466 10.4818L9.48466 11.0578L8.73266 11.0898L8.31666 11.7298L8.06066 11.0258L7.32466 10.8338L7.91666 10.3538L7.86866 9.60183ZM18.3487 11.4738L18.0287 12.1778L18.4287 12.8178L17.6767 12.7378L17.1807 13.3138L17.0207 12.5778L16.3327 12.2898L16.9887 11.9058L17.0367 11.1538L17.5967 11.6498L18.3487 11.4738ZM18.6527 13.2658L18.9887 13.9538L19.7407 14.0658L19.1967 14.5938L19.3247 15.3298L18.6527 14.9778L17.9807 15.3298L18.1087 14.5938L17.5647 14.0658L18.3167 13.9538L18.6527 13.2658ZM5.16466 13.1858L5.50066 13.8738L6.25266 13.9698L5.70866 14.4978L5.83666 15.2498L5.16466 14.8978L4.49266 15.2498L4.62066 14.4978L4.07666 13.9698L4.82866 13.8738L5.16466 13.1858ZM5.66066 11.3458L6.38066 11.5698L6.98866 11.1058V11.8738L7.61266 12.2898L6.89266 12.5298L6.68466 13.2658L6.23666 12.6578L5.48466 12.6738L5.91666 12.0658L5.66066 11.3458Z"
                    fill="white" />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_4915_40006">
                <rect
                    width="36"
                    height="24"
                    fill="white"
                    transform="translate(-6.03516 0.0664062)" />
            </clipPath>
        </defs>
    </svg>
`,p=L("venezuela_rounded",l),n=L("VEF",l);export{n as VEF,s as Venezuela,p as VenezuelaRounded};
